var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.484807 5.40056C0.365379 5.28113 0.317608 5.13782 0.317608 4.97062C0.317608 4.8273 0.365379 4.68399 0.484807 4.56456L4.68866 0.551792C4.92752 0.336823 5.2858 0.336823 5.50077 0.575678C5.71574 0.790648 5.71574 1.17282 5.47688 1.38779L2.30011 4.39736H10.4451C10.7556 4.39736 11.0183 4.66011 11.0183 4.97062C11.0183 5.30501 10.7556 5.54387 10.4451 5.54387H2.30011L5.47688 8.57733C5.71574 8.7923 5.71574 9.15059 5.50077 9.38944C5.2858 9.6283 4.92752 9.6283 4.68866 9.41333L0.484807 5.40056Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.624fa33a6c5da1108075c397df2bc1ad.svg";
export { ForwardRef as ReactComponent };